import {
  format,
  isSameYear,
  fromUnixTime,
  formatDistanceToNow,
  isToday,
  isYesterday,
} from 'date-fns';
import en from 'date-fns/locale/en-US';
import he from 'date-fns/locale/he';

export default {
  methods: {
    messageStamp(time, dateFormat = 'h:mm a') {
      const unixTime = fromUnixTime(time);
      return format(unixTime, dateFormat);
    },
    timestampToDate(time, dateFormat = 'dd/MM/yy') {
      const unixTime = time instanceof Date ? time : fromUnixTime(time);
      return format(unixTime, dateFormat);
    },
    messageStampFull(time, dateFormat = 'dd/MM/yy HH:mm') {
      const unixTime = time instanceof Date ? time : fromUnixTime(time);
      return format(unixTime, dateFormat);
    },
    messageTimestamp(time, dateFormat = 'MMM d, yyyy') {
      const messageTime = fromUnixTime(time);
      const now = new Date();
      const messageDate = format(messageTime, dateFormat, {
        locale: this.$root.$i18n.locale === 'he' ? he : en,
      });
      if (!isSameYear(messageTime, now)) {
        return format(messageTime, 'LLL d y, h:mm a', {
          locale: this.$root.$i18n.locale === 'he' ? he : en,
        });
      }
      return messageDate;
    },
    plainTimestamp(time, dateFormat) {
      return format(fromUnixTime(time), dateFormat, {
        locale: this.$root.$i18n.locale === 'he' ? he : en,
      });
    },
    dynamicTime(time) {
      const unixTime = fromUnixTime(time);
      return formatDistanceToNow(unixTime, { addSuffix: true, locale: this.$root.$i18n.locale === 'he' ? he : en });
    },
    dateFormat(time, dateFormat = 'MMM d, yyyy') {
      const unixTime = fromUnixTime(time);
      return format(unixTime, dateFormat);
    },
    relativeDate(time, dateFormat = 'dd/MM/yy') {
      const unixTime = time instanceof Date ? time : fromUnixTime(time);
      if (isToday(unixTime)) return window.WOOT.$root.$t('COMMON.TODAY');
      if (isYesterday(unixTime)) return window.WOOT.$root.$t('COMMON.YESTERDAY');
      return format(unixTime, dateFormat);
    },
    shortTimestamp(time) {
      const convertToShortTime = time
        .replace(/about|over|almost|/g, '')
        .replace('less than a minute ago', 'now')
        .replace(' minute ago', 'm')
        .replace(' minutes ago', 'm')
        .replace('a minute ago', 'm')
        .replace('an hour ago', 'h')
        .replace(' hour ago', 'h')
        .replace(' hours ago', 'h')
        .replace(' day ago', 'd')
        .replace('a day ago', 'd')
        .replace(' days ago', 'd')
        .replace('a month ago', 'mo')
        .replace(' months ago', 'mo')
        .replace(' month ago', 'mo')
        .replace('a year ago', 'y')
        .replace(' year ago', 'y')
        .replace(' years ago', 'y');
      return convertToShortTime;
    },
  },
};
